import * as React from 'react';

import Autocomplete from '@mui/material/Autocomplete';
import DebouncedTextField from './DebouncedTextField';

import { Option } from 'types/common';

const ClinicAutocomplete: React.FC<{
  options: Option[];
  onChange: (value: string) => void;
  handleChange: (value: Option | null) => void;
  placeholder?: string;
  name?: string;
  onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
}> = (props) => {
  return (
    <Autocomplete
      disablePortal
      options={props.options}
      sx={{
        width: 333,
        borderRadius: '10px',
        zIndex: 1000,
      }}
      onChange={(ev, newValue) => props.handleChange(newValue)}
      renderInput={(params) => {
        return (
          <DebouncedTextField
            onChange={props.onChange}
            params={params}
            name={props.name}
            onBlur={props.onBlur}
            placeholder={props.placeholder}
          />
        )
      }}

    />
  );
}

export default ClinicAutocomplete;
